import { Box, Stack, Typography } from '@mui/material'
import { useCurrentUser } from 'app/auth'
import { paths } from 'app/routes'
import { IconDocument, IconGitHub, IconPlus } from 'assets/icons'
import noProjectDataSrc from 'assets/images/no-project-data.png'
import { LinkButton } from 'elements/navigation'
import { useTranslation } from 'react-i18next'
import { createSearchParams, generatePath } from 'react-router-dom'

import { ProjectSettingsTab } from '../../pages/projects/details/project-settings/project-settings-page'
import { CreateTermButton } from '../../pages/projects/details/project-terms/components/create-term/create-term-button'

export const NoDataForThisProject = ({
  projectId,
  withButtons,
}: {
  projectId: string
  withButtons?: boolean
}) => {
  const { t } = useTranslation()

  const { permission: currentUserPermission } = useCurrentUser()

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      pt={12}
      width="100%"
      maxWidth={686}
      mx="auto"
    >
      <Box component="img" src={noProjectDataSrc} mb={1} />

      <Typography variant="h2" fontWeight={700} mb={4} textAlign="center">
        {t('projects.overview.no_data_for_this_project')}
      </Typography>

      {withButtons && (
        <Stack direction="row" spacing={1} width="100%">
          {currentUserPermission !== 'translator' && (
            <CreateTermButton
              projectId={projectId}
              variant="outlined"
              startIcon={
                <IconPlus sx={{ color: 'text.primary', fontSize: '24px' }} />
              }
              fullWidth
            />
          )}

          <LinkButton
            fullWidth
            variant="outlined"
            startIcon={<IconDocument sx={{ color: 'text.secondary' }} />}
            to={generatePath(paths.projectTerms, { projectId })}
          >
            {t('common.import')}
          </LinkButton>
          <LinkButton
            fullWidth
            variant="outlined"
            startIcon={<IconGitHub sx={{ color: 'text.secondary' }} />}
            to={{
              pathname: generatePath(paths.projectSettings, { projectId }),
              search: createSearchParams({
                tab: ProjectSettingsTab.Integrations,
              }).toString(),
            }}
          >
            {t('projects.overview.connect_integration')}
          </LinkButton>
        </Stack>
      )}
    </Box>
  )
}
